<span class="badge badge-pedido-status badge-pedido-status-outro">
    {{status.nome}}
</span>